<template>
  <div class="max-h-full max-w-[22rem]">
    <authenticate-login-welcome-section />

    <div class="my-20 space-y-20">
      <authenticate-provider-button
        provider="github"
        :icon="faGithub"
        auth-type="login"
        @provider-click="loginWithProvider"
      />

      <authenticate-provider-button
        provider="google"
        :icon="faGoogle"
        auth-type="login"
        @provider-click="loginWithProvider"
      />

      <div class="text-13 w-full text-center leading-[0.0625rem]">
        <span class="bg-white p-4 text-gray-500 dark:bg-black dark:text-gray-300">
          {{ t('login.alternativeOption') }}
        </span>
      </div>

      <authenticate-provider-button
        provider="email"
        :icon="faEnvelope"
        auth-type="login"
        @email-click="loginWithEmail"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { faGithub, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';

definePageMeta({
  layout: 'authentication',
  name: 'login',
});

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const client = useSupabaseClient();

const confirmPage = { name: 'auth.confirm', query: route.query };

const loginWithProvider = async (provider: OAuthProvider) => {
  const { error } = await client.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: window.location.origin + router.resolve(confirmPage).href,
    },
  });

  if (error) useNotificationBanner(t(useHandleSupabaseError(error)), 'error');
};

const loginWithEmail = async () => {
  await navigateTo({ name: 'email-login' });
};
</script>
